


























































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import DataTableV2 from '@/app/ui/components/DataTableV2/index.vue'
import PaginationNav from '@/app/ui/components/PaginationNav/index.vue'
import PickupCorporateSpecialHandlingBadges from '@/app/ui/views/Pickup/PickupCorporateV2/components/PickupCorporateSpecialHandlingBadges/index.vue'
import PickupCorporatePhoneCell from '@/app/ui/views/Pickup/PickupCorporateV2/components/PickupCorporatePhoneCell/index.vue'
import PickupCorporateAddress from '@/app/ui/views/Pickup/PickupCorporateV2/components/PickupCorporateAddress/index.vue'
import {
  PickupCorporateTableRow,
  PickupCorporateTableSort,
  formatNFDStatusClass
} from './index.types'
import {
  DataObject,
  HeaderObject,
  SortValueObject
} from '@/app/ui/components/DataTableV2/type'
import PickupController from '@/app/ui/controllers/PickupController'
import { PickupCorporateV2 } from '@/domain/entities/Pickup'
import { Utils } from '@/app/infrastructures/misc'

@Component({
  name: 'PickupCorporateTable',
  components: {
    DataTableV2,
    PaginationNav,
    PickupCorporateSpecialHandlingBadges,
    PickupCorporatePhoneCell,
    PickupCorporateAddress
  }
})
class PickupCorporateTable extends Vue {
  @Prop({ type: Array, required: true, default: () => [] })
  readonly rows!: PickupCorporateTableRow[]

  @Prop({ type: Object, default: null })
  readonly sort!: PickupCorporateTableSort | null

  @Prop({ type: Boolean, default: false })
  readonly isLoading!: boolean

  @Prop({ type: Number, required: true, default: 1 })
  readonly page!: number

  @Prop({ type: Number, required: true, default: 10 })
  readonly perPage!: number

  @Prop({ type: Number, required: true, default: 0 })
  readonly totalItem!: number

  @Prop({ type: Array, default: () => [10, 50, 100] })
  readonly perPageOptions!: number[]

  controller = PickupController

  // Header Widths persis sesuai spesifikasi PRD/Figma
  headers: HeaderObject[] = [
    this.createHeader('No.', '60px'),
    this.createHeader('Order ID', '160px'),
    this.createHeader('Nama customer', '313px'),
    this.createHeader('Alamat', '250px'),
    this.createHeader('Estimasi koli/berat', '169px'),
    this.createHeader('Ekspektasi jadwal pickup', '200px'),
    this.createHeader('Tanggal CRRNFD', '160px', 'crrnfd_at', '12px'),
    this.createHeader('NFD status', '140px'),
    this.createHeader('Catatan untuk kurir', '200px'),
    this.createHeader('Atur', '200px')
  ]

  revealed: Set<string> = new Set()
  revealedAddress: Set<string> = new Set()

  get currentSortObject(): SortValueObject {
    return {
      name: this.sort?.field || '',
      direction: this.sort?.direction?.toUpperCase() || ''
    }
  }

  get formattedTableData(): DataObject[][] {
    return this.rows.map((row, index) => [
      this.createCell(`${index + 1 + this.controller.paginationData.perPage! * (this.controller.paginationData.page! - 1)}.`, '60px'),
      this.createCell(
        {
          shipmentId: row.shipmentId,
          specialHandlingLabels: row.specialHandlingLabels,
          executionPlatform: row.executionPlatform
        },
        '160px'
      ),
      this.createCell(
        {
          shipmentId: row.shipmentId,
          customerName: row.customerName,
          clientLabel: row.clientLabel,
          phoneMaskedDisplay: row.phoneMaskedDisplay,
          phonePlainDisplay: row.phonePlainDisplay,
          isPhoneRevealed: row.isPhoneRevealed,
          isPhoneRevealLoading: row.isPhoneRevealLoading
        },
        '313px'
      ),
      this.createCell(
        {
          shipmentId: row.shipmentId,
          isAddressRevealLoading: row.isAddressRevealLoading,
          latitude: row.latitude,
          longitude: row.longitude,
        },
        '250px'
      ),
      this.createCell(
        {
          shipmentId: row.shipmentId,
          label: row.estimateKoliBeratLabel
        },
        '169px'
      ),
      this.createCell(
        {
          shipmentId: row.shipmentId,
          date: Utils.formatTimeZone(Utils.formatDateWithIDLocale(row.estimateScheduleDate, "dddd, DD MMMM YYYY")),
          timeRange: row.estimateScheduleTimeRange
        },
        '200px'
      ),
      this.createCell(
        {
          shipmentId: row.shipmentId,
          date: row.crrnfdDate,
          time: row.crrnfdTime
        },
        '160px'
      ),
      this.createCell(
        {
          shipmentId: row.shipmentId,
          count: row.nfdCount,
          labelText: row.nfdCount > 5 ? '>5 NFD' : `${row.nfdCount} NFD`,
          statusClass: formatNFDStatusClass(row.nfdCount)
        },
        '140px'
      ),
      this.createCell(
        {
          shipmentId: row.shipmentId,
          label: row.note
        },
        '200px'
      ),
      this.createCell({
        shipmentId: row.shipmentId,
        executionPlatform: row.executionPlatform
      }, '200px')
    ])
  }

  handleSort(sortVal: SortValueObject): void {
    if (!sortVal.name) {
      this.$emit('sort', {
        field: '',
        direction: ''
      });
      return
    }
    const direction = sortVal.direction?.toUpperCase() === 'ASC' ? 'ASC' : 'DESC'
    this.$emit('sort', {
      field: sortVal.name,
      direction
    } as PickupCorporateTableSort)
  }

  handlePageChange(newPage: number): void {
    this.$emit('page-change', { page: newPage })
  }

  handlePerPageChange(newPerPage: number): void {
    this.$emit('per-page-change', { perPage: newPerPage })
  }

  private createHeader(
    title: string,
    width: string,
    sortName?: string,
    sortWidth?: string
  ): HeaderObject {
    return {
      title,
      customStyle: { minWidth: width, maxWidth: width },
      withSort: Boolean(sortName),
      sortName,
      sortStyle: sortName
        ? {
            marginLeft: sortWidth || '8px'
          }
        : undefined
    }
  }

  private createCell(value: DataObject['value'] | Record<string, unknown>, width: string): DataObject {
    return {
      value: value as DataObject['value'],
      customStyle: { minWidth: width, maxWidth: width }
    }
  }


  isRevealed(shipmentId: string, field: string): boolean {
    if (field === 'pickup_phone') {
      return this.revealed.has(`${shipmentId}-phone`)
    } else {
      return this.revealedAddress.has(`${shipmentId}-address`)
    }
  }

  findItem(shipmentId: string): PickupCorporateV2 | undefined {
    return this.controller.pickupCorporateDataV2.find(p => p.shipmentId === shipmentId)
  }


  async showField(shipmentId: string, field: string): Promise<void> {
    if (!shipmentId) return
    const item = this.findItem(shipmentId)
    if (!item) return
    try {
      const resp = await this.controller.adminContactShow({
        resource: 'shipment',
        resourceId: shipmentId,
        field: field,
        source: 'pickup_corporate'
      })

      if (field === 'pickup_phone') {
        if (item.pickup) item.pickup.phoneNumber = resp.value || '-'
        this.revealed.add(`${shipmentId}-phone`)
        this.revealed = new Set(this.revealed)
      } else if (field === 'pickup_address') {
        if (item.pickup) item.pickup.address = resp.value || ''
        this.revealedAddress.add(`${shipmentId}-address`)
        this.revealedAddress = new Set(this.revealedAddress)
      }
    } catch {
      /* ignore */
    }
  }

  hideField(shipmentId: string, field: string): void {
    const item = this.findItem(shipmentId)
    if (field === 'pickup_phone') {
      if (item?.pickup) {
        item.pickup.phoneNumber = ''
      }
      this.revealed.delete(`${shipmentId}-phone`)
      this.revealed = new Set(this.revealed)
    } else if (field === 'pickup_address') {
      if (item?.pickup) {
        item.pickup.address = ''
      }
      this.revealedAddress.delete(`${shipmentId}-address`)
      this.revealedAddress = new Set(this.revealedAddress)
    }
  }
  public getPickupData(index: number): PickupCorporateV2 {
    return this.controller.pickupCorporateDataV2[Number(index)]
  }

  resetRevealed() {
    this.revealed = new Set();
    this.revealedAddress = new Set();
  }

}

export default PickupCorporateTable
